import React, { useCallback, useEffect, useRef } from 'react';
import cx from 'classnames';

const ImageSelection = ({
  options,
  handleSelection,
  selectedOption,
  selectedOptions,
  highlightedOption,
  useAnimation,
  animatedOptions,
  useHover,
  onImageLoadError,
  onAllImagesFailed,
  playingOption,
  restOtherOptions,
  useGridLayout,
}) => {

  const failedImagesCountRef = useRef(0); // ref to maintain no. of images that fails to load
  const triggeredAllImagesFailedRef = useRef(false); // to prevent multiple calls to onAllImagesFailed for the same options array

  useEffect(() => {
    // Reset the failed images count and triggeredAllImagesFailedRef when options array changes
    failedImagesCountRef.current = 0;
    triggeredAllImagesFailedRef.current = false; 
  }, [options]);

  const handleImageLoadError = useCallback((imageUrl, formattedImageUrl) => {
    console.warn("Error loading image", imageUrl, formattedImageUrl, "failedImagesCount", failedImagesCountRef.current);
    failedImagesCountRef.current++;
    // Retry the image loading via fetch call to identify and log the error
    fetch(formattedImageUrl) // fetch by default would do a basic log in console if there are any errors - Sentry will capture this
      .then(response => {
        if (!response.ok) {
          console.warn("Response from fetch call was not ok ",response?.status," ",response?.statusText);
        }
      })
      .catch(error => {
        console.warn('Error fetching image via fetch call:', error?.message || error?.toString());
      });
    if (typeof onImageLoadError === 'function') onImageLoadError(imageUrl, formattedImageUrl);

    // Check if all images failed to load
    if (failedImagesCountRef.current >= options.length) {
      if (triggeredAllImagesFailedRef.current) return;
      triggeredAllImagesFailedRef.current = true;
      if (typeof onAllImagesFailed === 'function') {
        onAllImagesFailed();
      }
    }
  }, [options.length, onImageLoadError, onAllImagesFailed]);

  return (
    <div className={cx("imageSelection", { optionGrid: useGridLayout, narrating: restOtherOptions })}>
      {options.map(option => {
        const formattedImageUrl = option.imageUrl.replace("s3.amazonaws.com/amira-assets",process.env.ASSET_ROOT);
        return (
          <div
            className={cx("imageBox", {
              willAnimate: useAnimation,
              animate: animatedOptions.includes(option.key),
              selected: selectedOptions
                ? selectedOptions.includes(option.key)
                : selectedOption === option.key,
              highlighted: highlightedOption === option.key,
              playing: playingOption === option.key,
              resting: restOtherOptions && playingOption !== option.key,
              useHover: useHover,
            })}
            key={option.key}
          >
            <div className="answerBox">
              <img
                src={formattedImageUrl}
                alt={`Option ${option.key}`}
                onClick={() => handleSelection(option.key)}
                onError={() => handleImageLoadError(option?.imageUrl, formattedImageUrl)}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ImageSelection;